<div class="card">
  <div class="card-header pb-0">
    <div class="media-space-between">
      <h4>{{ "admin.locations.repository.title" | translate }}</h4>
      <div class="media-body">
        <form class="media-space-between" [formGroup]="formFilter">
          <app-search-field
            class="m-r-10"
            [form]="formFilter | asFormGroup"
            [filterOptions]="filter"
            inputFormControlName="companyName"
            [placeholder]="'placeholder.searchByCompanyName' | translate"
            (emitSelectedOptions)="saveOptionFilter($event)"
          ></app-search-field>
          <div 
            class="m-r-10" 
            *ngIf="isFranchise" 
            data-bs-placement="top" 
            [ngbTooltip]="selectedLocations.length < 2 ? ('tooltip.compare' | translate) : ''"
          >
            <button
              class="btn btn-primary"
              type="button"
              style="width: max-content"
              data-bs-toggle="modal"
              data-original-title="test"
              (click)="showCompareModal()"
              [disabled]="selectedLocations.length < 2"
            >
              {{ "buttons.compare" | translate }}
            </button>
          </div>
          <div class="m-r-10">
            <button
              class="btn btn-primary"
              type="button"
              style="width: max-content"
              data-bs-toggle="modal"
              data-original-title="test"
              (click)="onClickShowModal()"
              [disabled]="!isAuthorised"
            >
              {{ "buttons.addLocations" | translate }}
            </button>
          </div>
          <a
            class="btn btn-outline-primary project-box"
            [ngbTooltip]="'export.title' | translate"
            (click)="exportCSV(exportFile)"
          >
            <i class="icon-import"></i>
          </a>
        </form>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div
      class="table-responsive data-table table-scrollable"
      style="--max-h: 70vh"
    >
      <table class="table table-striped table-border-vertical custom-scrollbar">
        <thead>
          <tr *ngIf="!isFranchise">
            <th>LP</th>
            <th *ngIf="columnVisibility[0]" colspan="5">
              {{ "admin.locations.repository.demographicData" | translate }}
              <a (click)="toggleColumn(0)" type="button">
                <img src="assets/identity/collabs.svg" alt="collabs"
              /></a>
            </th>
            <th *ngIf="!columnVisibility[0]" colspan="1">
              {{ "admin.locations.repository.demographicData" | translate }}
              <a (click)="toggleColumn(0)" type="button">
                <img src="assets/identity/collabs.svg" alt="collabs"
              /></a>
            </th>
            <th *ngIf="columnVisibility[1]" colspan="3">
              {{ "admin.locations.repository.informations" | translate }}
              <a (click)="toggleColumn(1)" type="button">
                <img src="assets/identity/collabs.svg" alt="collabs"
              /></a>
            </th>
            <th *ngIf="!columnVisibility[1]" colspan="1">
              {{ "admin.locations.repository.informations" | translate }}
              <a (click)="toggleColumn(1)" type="button">
                <img src="assets/identity/collabs.svg" alt="collabs"
              /></a>
            </th>
            <th colspan="4" *ngIf="columnVisibility[2]">
              {{ "admin.locations.repository.coordinates" | translate }}
              <a (click)="toggleColumn(2)" type="button">
                <img src="assets/identity/collabs.svg" alt="collabs"
              /></a>
            </th>
            <th *ngIf="!columnVisibility[2]" colspan="1">
              {{ "admin.locations.repository.coordinates" | translate }}
              <a (click)="toggleColumn(2)" type="button">
                <img src="assets/identity/collabs.svg" alt="collabs"
              /></a>
            </th>
            <th colspan="2" *ngIf="columnVisibility[3]">
              {{ "admin.locations.repository.discount" | translate }}
              <a (click)="toggleColumn(2)" type="button">
                <img src="assets/identity/collabs.svg" alt="collabs"
              /></a>
            </th>
            <th *ngIf="!columnVisibility[3]" colspan="1">
              {{ "admin.locations.repository.discount" | translate }}
              <a (click)="toggleColumn(2)" type="button">
                <img src="assets/identity/collabs.svg" alt="collabs"
              /></a>
            </th>
            <th>Actions</th>
          </tr>
          <tr>
            <th>{{ isFranchise ? "LP" : "" }}</th>
            <ng-container *ngFor="let demographic of demographic">
              <th *ngIf="columnVisibility[0]">
                {{ demographic.label | translate }}
              </th>
            </ng-container>
            <th *ngIf="!columnVisibility[0]"></th>
            <ng-container *ngFor="let demographic of info">
              <th *ngIf="columnVisibility[1]">
                {{ demographic.label | translate }}
              </th>
            </ng-container>

            <th *ngIf="!columnVisibility[1]"></th>
            <ng-container *ngFor="let demographic of coordinates">
              <th *ngIf="columnVisibility[2]">
                {{ demographic.label | translate }}
              </th>
            </ng-container>

            <th *ngIf="!columnVisibility[2]"></th>
            <ng-container *ngFor="let demographic of discount">
              <th *ngIf="columnVisibility[3]">
                {{ demographic.label | translate }}
              </th>
            </ng-container>

            <th *ngIf="!columnVisibility[3]"></th>
            <th *ngIf="isFranchise">
              {{ "admin.locations.franchise.status" | translate }}
            </th>
            <th>{{ isFranchise ? "Actions" : ""}}</th>
          </tr>
        </thead>
        <tbody *ngIf="!loading && !forbidden">
          <tr
            *ngFor="
              let item of locationPartnersResult?.locationPartners;
              let i = index
            "
          >
            <td>
              <ng-template #none>
                {{ "undefined" | translate }}
              </ng-template>
              <div 
                *ngIf="isFranchise" 
                style="display: flex; flex-direction: row; width: 100%"
              >
                <div  
                  class="form-check checkbox checkbox-primary mb-0 ml-10"
                >
                  <input 
                    class="form-check-input"
                    type="checkbox" 
                    style="margin-right: 8px;"
                    [disabled]="selectedLocations.length >= 5 && !isChecked(item.companyName)"
                    [checked]="isChecked(item.companyName)"
                    (click)="toggleSelect(item.companyName)"
                    [id]="item.companyName"
                  />
                  <label class="form-check-label label" [for]="item.companyName">
                    <a [ngbTooltip]="selectedLocations.length >= 5 ? ('tooltip.maxSelected' | translate) : ('tooltip.selectToCompare' | translate)"
                      type="button"
                      [routerLink]="['statistics/']"
                      style="color: black;"
                      [ngStyle]="isFranchise ? { 'text-align': 'left' } : {}"
                      [queryParams]="{
                        companyName: item.companyName
                      }"
                    >
                      {{ item.companyName }}
                    </a>
                  </label>
                </div>
              </div>
              <div 
                *ngIf="!isFranchise" 
                style="display: flex; flex-direction: row;"
              >
                <a
                  type="button"
                  [routerLink]="['statistics/']"
                  style="color: black;"
                  [ngStyle]="isFranchise ? { 'text-align': 'left' } : {}"
                  [queryParams]="{
                    companyName: item.companyName
                  }"
                >
                  {{ item.companyName }}
                </a>
              </div>
            </td>
            <td *ngIf="columnVisibility[0]">
              <p *ngIf="item.region != null; else none">{{ item.region }}</p>
            </td>
            <td *ngIf="columnVisibility[0]">
              <ngb-highlight
                [result]="item.zoneName"
                *ngIf="item.zoneName != null; else none"
              ></ngb-highlight>
            </td>
            <td *ngIf="columnVisibility[0]">
              <ngb-highlight
                [result]="item.category"
                *ngIf="item.category != null; else none"
              ></ngb-highlight>
            </td>
            <td *ngIf="columnVisibility[0]">
              <div *ngIf="item.subCategories.length != 0; else none">
                <div *ngFor="let subCateory of item.subCategories">
                  {{ subCateory }}
                </div>
              </div>
            </td>
            <td *ngIf="columnVisibility[0]">
              <div *ngIf="item.tags.length != 0; else none">
                <div *ngFor="let tag of item.tags">
                  {{ tag }}
                </div>
              </div>
            </td>
            <td *ngIf="!columnVisibility[0]"></td>
            <td *ngIf="columnVisibility[1]">
              <span
                *ngIf="item.partnerStatus != null; else none"
                [ngClass]="
                  'badge ' +
                  badgeService.getBadgeByLocationPartnerStatus(
                    item.partnerStatus
                  )
                "
              >
                {{
                  "enumMapping.partnerStatus." + item.partnerStatus | translate
                }}
              </span>
              <ng-template #none>
                <span
                  [ngClass]="
                    'badge ' +
                    badgeService.getBadgeByLocationPartnerPaymentFrequency(
                      paymentFrequencyToShow.NONE
                    )
                  "
                >
                  {{ "undefined" | translate }}
                </span>
              </ng-template>
            </td>
            <td *ngIf="columnVisibility[1]">
              <p *ngIf="item.pilotPhaseEndDate != null; else none">
                {{ item.pilotPhaseEndDate | localizedDate }}
              </p>
            </td>
            <td *ngIf="!isFranchise && columnVisibility[1]">
              <span
                [ngbTooltip]="
                  item.archivedDate ? tooltipArchivedDate : null
                "
                placement="bottom"
                [container]="'body'"
                [ngClass]="
                  'badge ' +
                  badgeService.getBadgeForUserStatus(
                    isCollaboratorArchived(item.archivedDate)
                  )
                "
              >
                {{
                  userStatusEnumMapping[
                    isCollaboratorArchived(item.archivedDate)
                  ] | translate
                }}
              </span>

              <ng-template #tooltipArchivedDate>
                <div>
                  {{ item.archivedDate | localizedDate : "short" }}
                </div>
              </ng-template>
            </td>
            <td *ngIf="!columnVisibility[1]"></td>
            <td *ngIf="columnVisibility[2]">
              <p
                *ngIf="
                  item.firstName != null || item.lastName != null;
                  else none
                "
              >
                {{ item.firstName }} {{ item.lastName }}
              </p>
            </td>
            <td *ngIf="columnVisibility[2]">
              <ngb-highlight
                [result]="item.email"
                *ngIf="item.email != null; else none"
              ></ngb-highlight>
            </td>
            <td *ngIf="columnVisibility[2]">
              <p *ngIf="item.phone != null; else none">
                {{ item.phone }}
              </p>
            </td>
            <td *ngIf="columnVisibility[2]">
              <ng-container
                *ngFor="let chunk of item.companyAddress | newline : 20"
              >
                {{ chunk }}<br />
              </ng-container>
            </td>
            <td *ngIf="!columnVisibility[2]"></td>
            <td *ngIf="columnVisibility[3]">
              <p *ngIf="item.price != null; else none">
                {{ item.price }}
              </p>
            </td>
            <td *ngIf="columnVisibility[3]">
              <p *ngIf="item.paymentFrequency; else paymentNone">
                <span
                  [ngClass]="
                    'badge ' +
                    badgeService.getBadgeByLocationPartnerPaymentFrequency(
                      item.paymentFrequency
                    )
                  "
                >
                  {{
                    "enumMapping.paymentFrequency." + item.paymentFrequency
                      | translate
                  }}
                </span>
              </p>
              <ng-template #paymentNone>
                <span
                  [ngClass]="
                    'badge ' +
                    badgeService.getBadgeByLocationPartnerPaymentFrequency(
                      paymentFrequencyToShow.NONE
                    )
                  "
                >
                  {{ "undefined" | translate }}
                </span>
              </ng-template>
            </td>
            <td *ngIf="!columnVisibility[3]"></td>
            <td *ngIf="isFranchise && !item.archivedDate">
              <div>
                <span
                  [ngClass]="
                    'badge ' +
                    badgeService.getBadgeByLocationPartnerActiveStatus(
                      getActiveStaus(item)
                    )
                  "
                >
                  {{
                    "enumMapping.franchiseStatus." + getActiveStaus(item)
                      | translate
                  }}
                </span>
              </div>
            </td>
            <td *ngIf="isFranchise && item.archivedDate">
              <span
                [ngbTooltip]="
                  item.archivedDate ? tooltipArchivedDate : null
                "
                placement="bottom"
                [container]="'body'"
                [ngClass]="
                  'badge ' +
                  badgeService.getBadgeForUserStatus(
                    isCollaboratorArchived(item.archivedDate)
                  )
                "
              >
                {{
                  userStatusEnumMapping[
                    isCollaboratorArchived(item.archivedDate)
                  ] | translate
                }}
              </span>

              <ng-template #tooltipArchivedDate>
                <div>
                  {{ item.archivedDate | localizedDate : "short" }}
                </div>
              </ng-template>
            </td>
            <td>
              <app-drop-zone-options
                [options]="getOptions(item.archivedDate)"
                (optionSelected)="saveOption($event, item)"
              ></app-drop-zone-options>
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
        {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
      </div>
      <div
        *ngIf="locationPartnersResult?.count == 0 && !loading && !forbidden"
        class="d-flex justify-content-center m-t-20"
      >
        {{ "noData" | translate }}
      </div>
      <div *ngIf="loading && !forbidden">
        <ng-container style="float: right" class="flex">
          <div class="loader-box">
            <div class="loader-34"></div>
          </div>
          <h6 class="col align-self-center f-w-600" style="text-align: center">
            {{ "fetching" | translate }}
          </h6>
        </ng-container>
      </div>
    </div>
    <app-pager
      [count]="locationPartnersResult?.count ?? 0"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"
      (emitChangePage)="changePage($event)"
      (emitChangePageSize)="itemsPerPageChange($event)"
    ></app-pager>
  </div>
</div>

<ng-template #exportFile let-modal id="exportFile">
  <div class="modal-header">
    <h4 class="modal-title" id="exportFile">
      {{ "exportLP.title" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      {{ "exportLP.body" | translate }}
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-primary"
      data-bs-dismiss="modal"
      (click)="modal.dismiss('Cross click')"
    >
      {{ "buttons.close" | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="exportToCsv()">
      <span
        *ngIf="deletedIsLoading"
        class="spinner-border spinner-border-sm mr-1"
      ></span>
      {{ "buttons.confirm" | translate }}
    </button>
  </div>
</ng-template>
